import {openSupport} from './messenger';
import Icons from '@/ui/IconButton/Icons';
import IconButton from '@/ui/IconButton/IconButton';

/** The Support page's ways to reach us: the messenger, its Help tab, and email. */
export default function SupportActions() {
    return (
        <nav className="support-form__actions" aria-label="Support options">
            <IconButton type={Icons.COMMENTS} label="Start a support conversation" onClick={() => openSupport({newConversation: true})}/>
            <IconButton type={Icons.SEARCH} label="Search documentation" onClick={() => openSupport({help: true})}/>
            <IconButton type={Icons.EMAIL} label="Email support" onClick={() => { window.open('mailto:support@outlawpractice.com', '_self'); }}/>
        </nav>
    );
}
